export default __webpack_public_path__ + "static/media/UserLogo.123b930f.svg";